
(() => {
    const formSubmitSuccess = document.querySelectorAll(".form-submit-success");

    if (formSubmitSuccess.length <= 0) {
        return;
    }

    formSubmitSuccess.forEach(element => {
        window.addEventListener("load", (event) => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                "event": "form_submit_success"
            });
        });
    });
})();
